const createReducer = (initialState, fnMap) => (state = initialState, action) => {
  const handler = fnMap[action.type]

  return handler ? handler(state, action) : state
}

export default createReducer
